import {NgModule} from '@angular/core';
import {FilePreviewComponent} from './file-preview.component';
import {CommonModule} from '@angular/common';
import {DirectivesModule} from '@helpers/directives/directives.module';
import {PipesModule} from '@pipes/pipes.module';
import {LayoutModule} from '@layoutComponents/layout.module';
import {IconsModule} from '@lab365/icons';

/**
 * Модуль для компонента предпросмотра файлов
 */

@NgModule({
    declarations: [FilePreviewComponent],
    imports: [
        DirectivesModule,
        PipesModule,
        CommonModule,
        LayoutModule,
        IconsModule,
    ],
    exports: [FilePreviewComponent],
})
export class FilePreviewModule {}
